


import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";

import logo from "../../images/24k1.jpg";
import login from "../../images/login.png";
import "../../css/navbar.css"; // Custom CSS file

export const Navbar = () => {

  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleLogin = () => {
    navigate("/login");
  };

  return (
    <nav className={`custom-navbar ${scrolled ? "scrolled" : ""}`}>
      <div className="logo-container" onClick={() => { navigate("/"); }}>
        <img src={logo} alt="Logo" className="logo" />
      </div>

      <ul className={`nav-links ${menuOpen ? "open" : ""}`}>
        <li>
          <Link to="/">Home</Link>
        </li>
        <li className="dropdown">
          <span className="dropdown-toggle">Discover Projects</span>
          <ul className="dropdown-menu">
            <li><Link to="/new-projects/new-launches">Just Launched</Link></li>
            <li><Link to="/new-projects/under-construction">Ongoing Projects</Link></li>
            <li><Link to="/new-projects/ready-to-move">Move In Ready</Link></li>
          </ul>
        </li>

        <li className="dropdown">
          <span className="dropdown-toggle">Gated Communities</span>
          <ul className="dropdown-menu">
            <li><Link to="">Apartments</Link></li>
            <li><Link to="">Villas</Link></li>
            <li><Link to="">plot</Link></li>
          </ul>
        </li>

        <li className="dropdown">
          <span className="dropdown-toggle">Plots </span>
          <ul className="dropdown-menu">
            <li><Link to="/Plots/Residential">Residential Plots</Link></li>
            <li><Link to="/Plots/Commercial">Commercial Plots</Link></li>
          </ul>
        </li>

        <li>
          <Link rel="canonical" to="/">Awards</Link>
        </li>
        <li>
          <Link rel="canonical" to="/">Builders</Link>
        </li>
        <li>
          <Link rel="canonical" to="/about">About Us</Link>
        </li>
        <li>
          <Link rel="canonical" to="/contact">Contact Us</Link>
        </li>
        <li>
          <a href="tel:+91" className="call-btn">Call Us</a>
        </li>
        <li className="login-btn" onClick={handleLogin}>
          <img src={login} alt="Login" className="login-icon" /> Login
        </li>
      </ul>
      <div
        className={`menu-toggle ${menuOpen ? "open" : ""}`}
        onClick={() => setMenuOpen(!menuOpen)}
      >
        <span></span>
        <span></span>
        <span></span>
      </div>
    </nav>
  );
};
